import { Button } from "@/components/button";
import { useDesignMaxTheme } from "@/packages";
import { FONT } from "@/styles";
import { Center, Flex, Text } from "@chakra-ui/react";
import { handleChoiceRoom } from "../../handler";
import type { ChoiceRoomProps } from "./choiceRoom.type";

export const ChoiceRoom = ({ dayNight, price, newOnPrice, newOffPrice, ...rest }: ChoiceRoomProps) => {
    const { isAvailableBook, isChoiceRoom, setIsChoiceRoom, setNewOffPrice, setNewOnPrice } = rest;
    const { COLORS } = useDesignMaxTheme();

    return (
        <Center
            w="100%"
            rowGap="16px"
            justifyContent="space-between"
            alignItems="flex-end"
            sx={{
                "& > button": {
                    ...FONT("pretendard", 16, 700),
                    color: isAvailableBook ? COLORS.black : COLORS.white,
                    bgColor: isAvailableBook ? COLORS.white : COLORS.gray[500],
                    border: isAvailableBook ? `1px solid ${COLORS.gray[500]}` : "none",
                    "&:hover": {
                        border: isAvailableBook ? `1px solid ${COLORS.pink}` : "none",
                        color: isAvailableBook ? COLORS.pink : "none",
                    },
                    "&.check": {
                        color: COLORS.white,
                        bgColor: COLORS.pink,
                        border: "none",
                    },
                },
            }}
        >
            <Button
                size="medium"
                round="pill"
                disabled={!isAvailableBook}
                className={isChoiceRoom ? "check" : ""}
                onClick={() =>
                    handleChoiceRoom({ isChoiceRoom, price, setIsChoiceRoom, setNewOffPrice, setNewOnPrice })
                }
            >
                {isAvailableBook ? "객실 선택" : "예약 마감"}
            </Button>
            <Flex
                flexDir="column"
                alignItems="flex-end"
                sx={{
                    "& > div": {
                        ...FONT("pretendard", 16, 300, 1.0),
                    },
                }}
            >
                <Flex textDecoration="line-through">{newOnPrice.toLocaleString()}원</Flex>
                <Flex alignItems="center" columnGap="4px">
                    <Text fontSize="24px" fontWeight={700} pl="4px" boxSizing="border-box">
                        {newOffPrice.toLocaleString()}
                    </Text>
                    <Text>원</Text>
                    <Text flexShrink={0}>/ {dayNight}박</Text>
                </Flex>
            </Flex>
        </Center>
    );
};
